import { render } from "./edit-account.vue?vue&type=template&id=d805314c"
import script from "./edit-account.vue?vue&type=script&lang=js"
export * from "./edit-account.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__